import {ValidationError} from "./validation";

export const PHONE_REGEX_SOURCE = "\\+\\d{2,3}\\d{9}";

const PHONE_REGEX = new RegExp(`^${PHONE_REGEX_SOURCE}$`);
const MAX_LENGTH = 13;

export const phoneInputProps = {
    inputMode: "numeric" as const,
    pattern: PHONE_REGEX_SOURCE,
    minLength: 12,
    maxLength: MAX_LENGTH,
};

export function normalizePhoneNumber(value: string, maxLength = MAX_LENGTH): string {
    const cleaned = value.replace(/[^\d+]/g, "");
    const normalized = cleaned.startsWith("+")
        ? `+${cleaned.slice(1).replace(/\+/g, "")}`
        : cleaned.replace(/\+/g, "");

    return normalized.slice(0, maxLength);
}

export function isValidPhoneNumber(value: string): boolean {
    return PHONE_REGEX.test(value.trim());
}

function getPhoneNumberError(
    value: string,
    errorKey = "phoneNumberValidation.invalid"
): ValidationError | null {
    if (!value.trim()) {
        return null;
    }

    if (!isValidPhoneNumber(value)) {
        return {key: errorKey};
    }

    return null;
}

export function validatePhoneNumber(
    value: string,
    errorKey = "phoneNumberValidation.invalid"
): ValidationError | null {
    return getPhoneNumberError(value, errorKey);
}
